import React, { createContext, useContext, useState, useCallback } from "react";
import { content } from "../mock";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("rpc_lang") || "es");

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "es" ? "en" : "es";
      localStorage.setItem("rpc_lang", next);
      return next;
    });
  }, []);

  const setLanguage = useCallback((l) => {
    localStorage.setItem("rpc_lang", l);
    setLang(l);
  }, []);

  const t = content[lang];

  return (
    <LanguageContext.Provider value={{ lang, toggle, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
